'use strict';

angular.module('angus.controllers').controller('excessCallsSubRegSettingsCtrl', [
    '$scope', 'constantsService', 
    function($scope, constantsService) {

        $scope.periodIndicators = constantsService.serviceExtendedPeriodIndicators.enums;
        $scope.ieoOptions       = constantsService.includeExcludeOnly.enums;
    }
]);